import {
  AddParameterDialogNew,
  AddParameterDialogProps,
} from '@/modules/patients/components/patient-details/therapy/dialogs/add-parameter-dialog-new'
import {dialog} from '@cypro/ui/components'

const ADD_PARAMETER_DIALOG_ID = 'add-parameter'

export function openAddParameterDialog(props: AddParameterDialogProps) {
  try {
    dialog.remove(ADD_PARAMETER_DIALOG_ID)
  } catch {}

  return dialog.open(ADD_PARAMETER_DIALOG_ID, {
    children: <AddParameterDialogNew {...props} />,
    scrollBehavior: 'inside',
    size: 'cover',
    contentProps: {
      overflow: 'hidden',
      height: 'max-content',
      maxWidth: '80rem',
    },
    hideCloseButton: true,
  })
}

export function closeAddParameterDialog(value = true) {
  return dialog.close(ADD_PARAMETER_DIALOG_ID, value)
}
